import React, {useRef, useState} from 'react';
import {Grid, Typography} from "@mui/material";

export const Apartado_Video_Dos = ({url, posterUrl = '', setTermino, item, termino}) => {
    const tiempoMaximoVisto = useRef(0);
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [hasStarted, setHasStarted] = useState(false);
    const [progressPercent, setProgressPercent] = useState(0);

    // Manejador del evento nativo onTimeUpdate
    const handleTimeUpdate = (e) => {
        const video = e.target;
        if (!video) return;

        const currentTime = video.currentTime;
        const duration = video.duration;

        if (!currentTime || !duration) return;

        // Actualizar porcentaje de la barra personalizada
        const pct = (currentTime / duration) * 100;
        setProgressPercent(Math.min(pct, 100));

        // Bloqueo si el usuario intenta adelantar más de 1.5 segundos de lo visto
        if (currentTime > tiempoMaximoVisto.current + 1.5) {
            video.currentTime = tiempoMaximoVisto.current; // Regresa al tiempo permitido directamente
        } else {
            tiempoMaximoVisto.current = Math.max(currentTime, tiempoMaximoVisto.current);
        }
    };

    const togglePlay = (e) => {
        if (e) e.stopPropagation();

        if (!hasStarted) setHasStarted(true);

        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
                setIsPlaying(false);
            } else {
                videoRef.current.play();
                setIsPlaying(true);
            }
        }
    };
    return (
        <div style={styles.cardContainer}>
            <div style={styles.playerWrapper} onClick={togglePlay}>

                {/* ETIQUETA NATIVA HTML5: Garantiza que iOS obedezca el reproductor inline */}
                <video
                    ref={videoRef}
                    src={url}
                    style={styles.videoElement}

                    // ATRIBUTOS OBLIGATORIOS PARA IOS SAFARI
                    playsInline={true}
                    webkit-playsinline="true"
                    x5-playsinline="true"

                    // Desactivar controles e interacciones nativas del sistema
                    controls={false}
                    controlsList="nofullscreen nodownload noremoteplayback"
                    disablePictureInPicture={true}

                    // Eventos
                    onTimeUpdate={handleTimeUpdate}
                    onEnded={() => {
                        setIsPlaying(false);
                        setTermino(true)
                    }}
                    onContextMenu={(e) => e.preventDefault()}
                />

                {/* Capa superpuesta / Botón Play */}
                {(!hasStarted || !isPlaying) && (
                    <div style={styles.overlay}>
                        {!hasStarted && posterUrl && (
                            <img src={posterUrl} alt="Preview" style={styles.posterImage}/>
                        )}

                        <Grid
                            container
                            justifyContent={'center'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: -3}}>
                                <Typography sx={{color: '#e50914', fontWeight: 700}} >{termino ? 'Repetir' :  `INICIAR VIDEO ${item.numero}`}</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                                <button
                                    style={styles.playButton}
                                    onClick={togglePlay}
                                    aria-label="Reproducir"
                                >
                                    <svg width="28" height="32" viewBox="0 0 24 28" fill="none">
                                        <path d="M23 14L2 26V2L23 14Z" fill="white"/>
                                    </svg>
                                </button>
                            </Grid>



                        </Grid>
                    </div>
                )}

                {/* Barra de progreso de solo lectura */}
                <div style={styles.progressBarContainer}>
                    <div
                        style={{
                            ...styles.progressBarFill,
                            width: `${progressPercent}%`,
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

// ESTILOS DE DISEÑO CUIDADOS (Landing / Inmersión)
const styles = {
    cardContainer: {
        width: '100%',
        maxWidth: '800px',
        margin: '0 auto',
        padding: '10px',
    },
    playerWrapper: {
        position: 'relative',
        width: '100%',
        aspectRatio: '16/9', // Ajusta según la relación nativa de tu video (16/9, 4/3, etc.)
        borderRadius: '16px',
        overflow: 'hidden',
        backgroundColor: '#000000', // Las barras negras cuando el video no llena el ratio perfecto
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.4)',
        cursor: 'pointer',
        WebkitTapHighlightColor: 'transparent',
    },
    videoElement: {
        width: '100%',
        height: '100%',
        // 1. CAMBIO CLAVE: 'contain' evita el zoom y muestra el 100% del cuadro sin recortar
        objectFit: 'contain',
        display: 'block',
    },
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.35)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 10,
    },
    posterImage: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        // 2. También en la miniatura para que coincida exactamente con el video
        objectFit: 'contain',
        zIndex: 1,
    },
    playButton: {
        position: 'relative',
        zIndex: 2,
        width: '72px',
        height: '72px',
        borderRadius: '50%',
        backgroundColor: '#e50914',
        border: 'none',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        boxShadow: '0 0 25px rgba(229, 9, 20, 0.6)',
    },
    progressBarContainer: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: '6px',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        zIndex: 15,
        pointerEvents: 'none',
    },
    progressBarFill: {
        height: '100%',
        backgroundColor: '#e50914',
        transition: 'width 0.1s linear',
    },
};